export async function generatePrintSneHtml(sneDetails) {
    return `
      <!DOCTYPE html>
      <html lang="pt-BR">
      <link rel="icon" type="image/png" href="/assets/logos/logo.png" />
      <head>
        <meta charset="UTF-8">
        <title>GOTT - Gestor de Operações de Transito e Transporte</title>
        <style>
          body {
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-size: 14px;
            line-height: 1.42857143;
            color: #333;
            background-color: #fff;
            margin: 0;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 4px;
          }
          td {
            border: 1px solid #CCC;
            padding: 10px;
            vertical-align: top;
            line-height: 1.42857143;
            width: 33.33333333%;
          }
          small {
            margin-top: 1px;
            margin-bottom: 10px;
            display: block;
            font-size: 14px;
            line-height: 8px;
          }
          strong {
            font-weight: bold !important;
          }
          p {
            margin: 0 !important;
          }
          h1 {
            font-weight: 500;
            line-height: 1.1;
            margin: 0.67em 0;
          }
          h4 {
            margin-top: 20px;
            margin-bottom: 10px;
            font-size: 14px;
            line-height: 1.1;
            font-weight: bold;
          }
          .text-center {
            text-align: center;
          }
          .highlighted {
            font-size: 36px;
            font-weight: 500;
            text-align: center;
            margin: 5px 0;
            text-decoration: underline;
            text-transform: uppercase;
          }
          .head-text {
            font-size: 14px;
            line-height: 1.42857143;
            color: #333;
            padding: 0 15px;
          }
          .image-container {
            padding-left: 15px;
            padding-right: 15px;
            min-height: 1px;
          }
          .align-middle {
            vertical-align: middle !important;
          }
          @media print {
            @page {
              margin: 0;
              size: auto;
            }
            body {
              margin: 0;
            }
            header, footer {
              display: none;
            }
          }
        </style>
      </head>
      <body>
        <div class="cape" style="max-width: 800px; margin: 16px">
          <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 8px;">
            <div class="image-container" style="width: 25%; text-align: center; transform: translateX(-15px);">
              <img src="/assets/logos/${sneDetails?.company_logo}" width="100%"  alt=""/>
            </div>
            <div class="head-text" style="text-align: center;">
              <strong>${sneDetails?.company_state_description}</strong><br/>
              <strong>${sneDetails?.company_owner_name}</strong><br/>
              <strong>${sneDetails?.company_name}</strong>
            </div>
            <div class="image-container" style="width: 25%; text-align: center;">
              <img src="/assets/logos/${sneDetails?.company_owner_logo}" width="100%"  alt=""/>
            </div>
          </div>
    
          <h4 class="text-center">DEMONSTRATIVO SNE</h4>
    
  
          <table>
            <tr>
              <td colspan="3"><small>Proprietário</small> <strong>${sneDetails?.vehicle.nomeProprietario ? sneDetails?.vehicle.nomeProprietario : ''}</strong></td>
            </tr>
            <tr>
              <td colspan="3">
                  <small>Endereço</small>
                  <strong>
                    ${sneDetails?.vehicle.enderecoImovelProprietario ? sneDetails?.vehicle.enderecoImovelProprietario : ''}
                    ${sneDetails?.vehicle.numeroImovelProprietario ? sneDetails?.vehicle.numeroImovelProprietario : ''},
                    ${sneDetails?.vehicle.bairroImovelProprietario ? sneDetails?.vehicle.bairroImovelProprietario : ''},
                    ${sneDetails?.vehicle.cepImovelProprietario ? sneDetails?.vehicle.cepImovelProprietario : ''}
                  </strong>
              </td>
            </tr>
            <tr>
              <td colspan="2"><small>Município</small> <strong>${sneDetails?.vehicle.cidadeImovelProprietario ? sneDetails?.vehicle.cidadeImovelProprietario : ''}</strong></td>
              <td><small>UF</small> <strong>${sneDetails?.vehicle.ufImovelProprietario ? sneDetails?.vehicle.ufImovelProprietario : ''}</strong></td>
            </tr>
            <tr>
              <td><small>Placa</small> <strong>${sneDetails?.vehicle.placa ? sneDetails?.vehicle.placa : ''} ${sneDetails?.vehicle.ufPlaca ? sneDetails?.vehicle.ufPlaca : ''}</strong></td>
              <td><small>Marca/Modelo</small> <strong>${sneDetails?.vehicle.descricaoMarcaModelo ? sneDetails?.vehicle.descricaoMarcaModelo : ''}</strong></td>
              <td><small>Adesão SNE</small> <strong>${sneDetails?.sne_date ? sneDetails?.sne_date : 'NÃO ADERIU'}</strong></td>
            </tr>
          </table>
    
          
        </div>
      </body>
      </html>
  `;
}
